import React, { useContext, useEffect, useState } from "react";
import { Card, Button, Col, Row } from "react-bootstrap";
import { List } from "antd-mobile";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import PsContext from "../../context";
import OpenPaymentFormLink from "../../students/openPaymentForm/openPaymentFormLink";
import {
  S3_BUCKET_HOME_PATH,
  APP_TYPE,
  DB_POSTFIX,
  DENOMINATION,
  MOB_ICONS,
  baseUrl,
  queryParam,
  upperCase,
} from "../../utils";
import CollegeLogo from "../collegeLogo";
import Header from "../header";
import SelectCollegeName from "../selectCollegeName";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Footer from "../footer";
const LoginBy = (props) => {
  const context = useContext(PsContext);
  const navigation = useNavigate();
  const [loader, setLoader] = useState(false);

  const [validated, setValidated] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [serverResponse, setServerResponse] = useState("");
  const [terms, setTerms] = useState([]);

  useEffect(() => {
    ListColleges();
  }, []);

  useEffect(() => {
    console.log(context.settingValue("mob_allow_stu_update_profile", ""));
    /* if (APP_TYPE != "SAAS") loadTerms(); */
    if (APP_TYPE != "SAAS") context.loadSettings();

    if (context.getStorage("update_stu_profile") == "yes") {
      navigation("/stu/update-profile");
    }
    const q = queryParam(window.location.search);
    if (q && q.did && q.did.length > 2) {
      context.setStorage("user_device_id", q.did);
    }
  }, []);
  /*   const loadTerms = () => {
    axios.post(ServiceUrl.LOGIN_V2.TERMS).then((res) => {
      if (res["data"].status == "1") {
        setTerms(res["data"].data);
      } else {
        Toast.show({
          content: res["data"].message || "Error",
          position: "top",
        });
        setLoader(false);
      }
      context.setLoader(false);
    });
  }; */

  const ListColleges = (form) => {
    setLoader(true);
    axios
      .post(ServiceUrl.STUDENTS.LIST_COLLEGES, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          setColleges(res["data"].data);
        }
        setLoader(false);
      });
  };

  if (context.logged == "yes") {
    let r =
      context.getStorage("login_by") == "staff" ? "/staff/app" : "/stu/app";
    return <Navigate to={r} replace={true} />;
    return null;
  } else {
    return (
      <>
        <Header
          title={/* context.settingValue("college_app_short_name") */ "TNDLS"}
          rightActions={[]}
          backAction={false}
          noBack={true}
        ></Header>

        <div className="" data-aos="zoom-in">
          <div className="container pt-3">
            <Row>
              <Col md={{ offset: 2, span: 8 }}>
                {!selectedRecords?.college_uuid && (
                  <List className="mb-5">
                    {colleges.map((item, j) => {
                      return (
                        <List.Item onClick={() => setSelectedRecords(item)}>
                          {item.college_name}
                        </List.Item>
                      );
                    })}
                  </List>
                )}
                {selectedRecords?.college_uuid && (
                  <div className="">
                    <div className="text-center">
                      <CollegeLogo />
                      <div className="mt-4 " style={{ fontSize: "16px" }}>
                        {APP_TYPE != "SASS" && (
                          <span style={{ fontWeight: "700" }}>
                            {upperCase(
                              context.settingValue("universityheader_name", "")
                            )}
                            <br />
                          </span>
                        )}
                        {APP_TYPE != "SASS" && (
                          <span className="text-muted fw-bolder">
                            {upperCase(
                              context.settingValue("enquiry_place", "")
                            )}
                          </span>
                        )}
                        {APP_TYPE != "SASS" && (
                          <span className="text-muted fw-bolder">
                            {selectedRecords.college_name}
                            <Button
                              variant="transparent"
                              onClick={() => setSelectedRecords([])}
                            >
                              <i class="fa-solid fa-arrows-rotate"></i>
                            </Button>
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="top-products-area p-3 mt-4">
                      <div className="container-sm">
                        <Row className="d-flex justify-content-center">
                          <Col xs={6} md={3} className="mt-3">
                            <Link
                              to={`/stu/login/${selectedRecords.college_uuid}`}
                            >
                              <Card>
                                <CardContent className="p-0 m-0">
                                  <Typography
                                    sx={{
                                      color: "text.secondary",
                                      fontSize: 14,
                                    }}
                                    className="d-flex justify-content-center align-content-center"
                                  >
                                    <img
                                      src={MOB_ICONS.STUDENT_LOGIN_IMG}
                                      style={{ width: "50px" }}
                                    />
                                  </Typography>
                                  <br />
                                  <Typography
                                    sx={{
                                      color: "text.secondary",
                                      fontSize: 14,
                                    }}
                                    className="d-flex justify-content-center align-content-center fw-bolder text-muted"
                                  >
                                    Student Login
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Link>
                          </Col>
                          <Col xs={6} md={3} className="mt-3">
                            <Link to="/staff/login">
                              <Card>
                                <CardContent className="p-0 m-0">
                                  <Typography
                                    sx={{
                                      color: "text.secondary",
                                      fontSize: 14,
                                    }}
                                    className="d-flex justify-content-center align-content-center"
                                  >
                                    <img
                                      src={MOB_ICONS.STAFF_LOGIN_IMG}
                                      style={{ width: "50px" }}
                                    />
                                  </Typography>
                                  <br />
                                  <Typography
                                    sx={{
                                      color: "text.secondary",
                                      fontSize: 14,
                                    }}
                                    className="d-flex justify-content-center align-content-center fw-bolder text-muted"
                                  >
                                    Staff Login
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Link>
                          </Col>
                        </Row>

                        {/*    {context.settingValue(
                        "mob_allow_stu_update_profile",
                        ""
                      ) == "1" && (
                        <div className="row mt-4 text-center fs-7">
                          <div class="col-md-12">
                            <Link to="/stu/register">Update Profile</Link>
                          </div>
                        </div>
                      )} */}
                        <div className="row mt-4">
                          <Col md={12} style={{ textAlign: "center" }}>
                            {terms.map((item, i) => (
                              <>
                                <Link to={"/terms-conditions/" + item.id}>
                                  {item.title}
                                </Link>{" "}
                                {i < terms.length - 1 && <> | </>}{" "}
                              </>
                            ))}
                          </Col>
                        </div>

                        <OpenPaymentFormLink />
                      </div>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>

        <Footer />
      </>
    );
  }
};
export default LoginBy;
